module.exports = __webpack_public_path__ + "6565f8120c2099632bb6d06f40373cde.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/screenprint-tshirt-white-design.png
// module id = 682
// module chunks = 0